/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Link_Web_DescriptionInputs */

const en_dialog_link_web_description = /** @type {(inputs: Dialog_Link_Web_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste any article, PDF, or newsletter link to convert it into audio.`)
};

const es_dialog_link_web_description = /** @type {(inputs: Dialog_Link_Web_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega cualquier enlace de artículo, PDF o boletín para convertirlo en audio.`)
};

/**
* | output |
* | --- |
* | "Paste any article, PDF, or newsletter link to convert it into audio." |
*
* @param {Dialog_Link_Web_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_link_web_description = /** @type {((inputs?: Dialog_Link_Web_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Link_Web_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_link_web_description(inputs)
	return en_dialog_link_web_description(inputs)
});